import sendEmailErrorWsp from './sendEmailErrorWsp'
import { formatWhatsAppPhone, sanitizeWhatsAppText, sendCurrentWhatsAppMessage } from './sendWhatsAppCurrent'
import { createProducerNewOrderTemplateParams, WHATSAPP_TEMPLATES } from './whatsappTemplates'

async function SendWsOrder(response) {
  const orderNote = { detail: response.detail, order: response.order ?? response.orderNote }
  const body = (number, name, numberOrder, producer, place, storeName) => {
    const phone = number.replace('+', '')
    let productsString = ''
    producer.forEach((product) => {
      productsString += ` ${product.qty} ${
        product.product.sale_format > 1
          ? product.qty > 1
            ? 'cajas '
            : 'caja'
          : product.qty > 1
            ? 'unidades'
            : 'unidad '
      } de ${product.product.name},`.toString()
    })
    return {
      app_env: process.env.REACT_APP_ENV,
      message_type: 'send_order',
      recipients: phone,
      template_name: 'send_order',
      language_code: 'es',
      body_vars: [
        {
          text: '{{1}}',
          val: name,
        },
        {
          text: '{{2}}',
          val: storeName,
        },
        {
          text: '{{3}}',
          val: place,
        },
        {
          text: '{{4}}',
          val: numberOrder,
        },
        {
          text: '{{5}}',
          val: productsString.toString(),
        },
      ],
    }
  }

  const createProducerNewOrderParams = (name, numberOrder, producer, place, storeName) => {
    return createProducerNewOrderTemplateParams({
      producerName: sanitizeWhatsAppText(name),
      storeName: sanitizeWhatsAppText(storeName),
      commune: sanitizeWhatsAppText(place),
      orderNumber: sanitizeWhatsAppText(numberOrder),
      itemsText: sanitizeWhatsAppText(body('', name, numberOrder, producer, place, storeName).body_vars[4].val),
    })
  }

  const postWs = async (number, name, numberOrder, producer, place, storeName) => {
    const recipient = formatWhatsAppPhone(number)

    try {
      await sendCurrentWhatsAppMessage({
        to: recipient,
        template: WHATSAPP_TEMPLATES.PRODUCER_NEW_ORDER,
        params: createProducerNewOrderParams(name, numberOrder, producer, place, storeName),
      })

      return {
        respuesta: {
          success: true,
          sent: 1,
          not_sent: 0,
          logs: [{ recipient }],
        },
      }
    } catch (error) {
      return {
        respuesta: {
          success: true,
          sent: 0,
          not_sent: 1,
          logs: [
            {
              recipient,
              error: error.message || 'No fue posible enviar el pedido por WhatsApp.',
            },
          ],
        },
      }
    }
  }
  // Enlista todos los productores del pedido
  const producers = Array.from(new Set(orderNote.detail.map((product) => product.product.producer.brand_name)))
  // agrupa los productos por productor
  let productsByProducer = []
  producers.forEach((producer) => {
    let products = orderNote.detail.filter((product) => product.product.producer.brand_name === producer)
    productsByProducer = [...productsByProducer, products]
  })
  // Se realiza el post por cada productor
  const send = productsByProducer.map((producer) => {
    return new Promise(async (resolve, reject) => {
      postWs(
        producer[0].product.producer.contact[0].phone,
        producer[0].product.producer.brand_name,
        orderNote.order.number,
        producer,
        orderNote.order.store_direction.municipality
          ? orderNote.order.store_direction.municipality
          : orderNote.order.store_direction.sub_region,
        orderNote.order.store.name,
      ).then((res) => {
        if (res.respuesta.success) {
          if (res.respuesta.sent === 1) {
            resolve({
              message: `Pedido enviado a productor ${producer[0].product.producer.brand_name}`,
              type: 'success',
            })
          } else if (res.respuesta.not_sent === 1) {
            sendEmailErrorWsp({
              production: Boolean(process.env.REACT_APP_ENV === 'production'),
              nameProducer: producer[0].product.producer.brand_name,
              nameStore: orderNote.order.store.name,
              error: res.respuesta.logs[0].error,
              numberOrder: orderNote.order.number,
              place: orderNote.order.store_direction.municipality
                ? orderNote.order.store_direction.municipality
                : orderNote.order.store_direction.sub_region,
              products: body(
                producer[0].product.producer.contact[0].phone,
                producer[0].product.producer.brand_name,
                orderNote.order.number,
                producer,
                orderNote.order.store_direction.municipality
                  ? orderNote.order.store_direction.municipality
                  : orderNote.order.store_direction.sub_region,
                orderNote.order.store.name,
              )
                .body_vars[4].val.replaceAll('\\n', '<br/>')
                .replaceAll('*', ''),
            })
            resolve({
              message: `Productor: ${producer[0].product.producer.brand_name} - ` + res.respuesta.logs[0].error,
              type: 'error',
            })
          }
        } else {
          resolve({
            message: `Error al enviar mensaje a productor ${producer[0].product.producer.brand_name}`,
            type: 'error',
          })
        }
      })
    })
  })
  return Promise.all(send).then((responses) => responses)
}
export default SendWsOrder
